import { useParams } from 'react-router';
import { useMount } from 'react-use';

import { trackPageViewedEvent } from './tracking';

type TrackPageViewedEventProps = {
  pageName: string;
};

export default function TrackPageViewedEvent({
  pageName,
}: TrackPageViewedEventProps) {
  const params = useParams();
  useMount(() => {
    const jobIdFromPath = 'jobId' in params ? params.jobId : undefined;
    const draftIdFromPath = 'draftId' in params ? params.draftId : undefined;
    const searchParams = new URLSearchParams(window.location.search);
    const jobId =
      searchParams.get('jobId') ||
      searchParams.get('jid') ||
      searchParams.get('job_id') ||
      jobIdFromPath;
    const jobDraftId = searchParams.get('jobDraftId') || draftIdFromPath;
    const applicationId =
      'applicationId' in params ? params.applicationId : undefined;
    const channelId = searchParams.get('cid');

    trackPageViewedEvent({
      pageName,
      properties: {
        ...(jobId ? { job_id: jobId } : {}),
        ...(jobDraftId ? { job_draft_id: jobDraftId } : {}),
        ...(applicationId ? { application_id: applicationId } : {}),
        ...(channelId ? { channel_id: channelId } : {}),
      },
    });
  });
  return null;
}
